import { handleLinkByTypeV2 } from "@/helpers/common/handleLinkByType";
import OfferTimeCountDown from "./OfferTimeCountDown";
import { countDownHandler } from "@/utils/global";
import Image from "@/components/global/Image";
import { useRouter } from "next/router";
import Link from "next/link";

const OfferEndDate = ({ headerJson = [] }) => {
  const activeData = headerJson?.find(
    (item) => item?.active && item?.key === "categories"
  );
  const category = activeData?.value?.[0];

  const { locale } = useRouter();

  return (
    <>
      {activeData?.active &&
        countDownHandler(category?.["date-to"]).isCountDown && (
          <Link
            href={handleLinkByTypeV2(category?.url, category?.type)}
            className="flex items-center gap-3 max-sm:justify-center"
          >
            {/* <HeaderDiscountIcon className="max-sm:size-5" /> */}
            <Image
              src={category?.img || "/imgs/offers-1.gif"}
              className="object-contain size-7 animate-bounce"
              alt=""
            />
            <div className="flex gap-1 text-xs font-bold text-red-600 max-lg:flex-wrap w-fit sm:text-sm sm:flex-col animate-pulse">
              <span>{category?.[`title-${locale}`]}</span>
              {activeData?.value?.[0]?.["show-time"] ? (
                <OfferTimeCountDown counter={category} />
              ) : null}
            </div>
          </Link>
        )}
    </>
  );
};

export default OfferEndDate;
